import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const StyledAddToWishlist = styled.button`
  display: flex;
  user-select: none;
  cursor: pointer;
  text-decoration: none !important;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;

  &:hover {
    text-decoration: underline !important;
    svg {
      color: ${theme.color.icon.highlight} !important;
    }
  }
`;
